<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("comprasPorCasas")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listCasas">{{$t("casa")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCasa"
                                           filterable
                                           :placeholder="$t('seleccionaCasa')"
                                           @change="getComprasCasas(true)">
                                    <el-option v-for="casa in listCasas"
                                               class="select-primary"
                                               :value="casa"
                                               :label="casa"
                                               :key="casa">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getComprasCasas">
                                    <el-option
                                            class="select-primary"
                                            :value=0
                                            label="Todos"
                                            :key=0>
                                    </el-option>
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.idBusiness"
                                               :label="business.nameNegocio"
                                               :key="business.idBusiness">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getComprasCasas">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="data.length > 0">
                    <div class="row justify-content-between div-export">
                        <div class="col-md-12 col-xs-12">
                            <i class="fa fa-info-circle"></i>
                            <small>
                                {{$t("infoCasas")}}
                            </small>
                        </div>
                        <div class="col-md-2 col-xs-12 text-left">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("fecha")}}</th>
                                <th>{{$t("subproductos")}}</th>
                                <th>{{$t("nombreProveedor")}}</th>
                                <th>{{$t("unidades")}}</th>
                                <th>{{$t("partes")}}</th>
                                <th>{{$t("precio")}}</th>
                                <th>{{$t("negocio")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in data">
                                <td>{{obj.date | parseDate}}</td>
                                <td>{{obj.nameSubproduct}}</td>
                                <td>{{obj.nameProv}}</td>
                                <td class="text-right">{{obj.ud}}</td>
                                <td class="text-right">{{obj.partes}}</td>
                                <td class="text-right">{{obj.total | currency}}</td>
                                <td>{{obj.nameNegocio}}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td></td>
                                <td></td>
                                <td class="text-right"><strong>{{getTotalUnidades}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPartes}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                <td></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <p><i class="fa fa-info-circle"></i>
                        <small>
                            {{$t("infoConsumo")}}
                        </small>
                    </p>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("gastos")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", this.$i18n.t("comprasPorCasas"));
            this.getCasas();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: null,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listCasas: [],
                idBusiness: 0,
                idCasa: 0,
                data: [''],
                respuesta:true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                // return "../api/public/index.php/casas/exportComprasCasas/PDF?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
                return this.$store.getters.apiUrl+"/casas/exportComprasCasas/PDF?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
     
            },
            urlExportExcel() {
                // return "../api/public/index.php/casas/exportComprasCasas/Excel?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
                return this.$store.getters.apiUrl+"/casas/exportComprasCasas/Excel?idBusiness=" + this.idBusiness + "&idCasa=" + this.idCasa + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            getTotalUnidades() {
                let uds = 0;
                this.data.forEach(function (d) {
                    uds += d.ud;
                });
                return uds;
            },
            getTotalPartes() {
                let partes = 0;
                this.data.forEach(function (d) {
                    partes += d.partes;
                });
                return partes;
            },
            getTotalPrecio() {
                let total = 0;
                this.data.forEach(function (d) {
                    total += d.total;
                });
                return total;
            }
        },
        methods: {
            getCasas() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "casas/getCasasByUser", config)
                    .then(function (response) {
                        vm.idCasa = response.data.result[0];
                        vm.listCasas = response.data.result;

                        vm.getComprasCasas();
                    })
                    .catch(function (error) {
                        vm.loading.close();
                        console.log(error);
                    });
            },
            getComprasCasas(resetNegocio) {
                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {

                        this.loading = true;

                        if (resetNegocio === true) {
                            this.idBusiness = 0;
                        }

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);


                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCasa: this.idCasa,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "casas/getComprasCasas", config)
                            .then(function (response) {
                                vm.loading = false;
                                if (response.data.response) {
                                    vm.data = response.data.result;
                                    vm.respuesta=true;

                                    let listBusiness = new Array();

                                    for (let i = 0; i < response.data.result.length; i++) {
                                        if (!vm.arrayContainsNegocio(listBusiness, response.data.result[i].nameNegocio)) {
                                            let negocio = new Object();
                                            negocio.idBusiness = response.data.result[i].idBusiness;
                                            negocio.nameNegocio = response.data.result[i].nameNegocio;
                                            listBusiness.push(negocio);
                                        }
                                    }
                                    vm.listBusinesses = listBusiness;

                                }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                                } 
                                else{
                                    vm.respuesta=false;
                                }

                            })
                            .catch(function (error) {
                                console.log(error);
                                vm.loading.close();
                            });
                    }
                }
            },
            arrayContainsNegocio(listBusiness, nameNegocio) {
                let found = false;
                for (let i = 0; i < listBusiness.length; i++) {
                    if (listBusiness[i]) {
                        if (listBusiness[i].nameNegocio === nameNegocio) {
                            found = true;
                            break;
                        }
                    }
                }
                return found;
            }
        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Casas/ComprasCasas.vue